import { type PropsWithChildren, useMemo } from 'react';

import { HoneycombDataContext } from '../context/honeycomb-data.context.js';
import { HoneycombExtentConfig } from '../context/honeycomb-extent-config.context.js';
import { HoneycombRequiredConfigProps } from '../types/honeycomb-internal.js';
import type { HoneycombTileData } from '../types/honeycomb.js';
import { removeDataMinDataMax } from '../utils/remove-data-min-data-max.js';

interface HoneycombFilteredDataProviderProps {
  data: HoneycombTileData[];
  config: HoneycombRequiredConfigProps;
}

export const HoneycombFilteredDataProvider = ({
  data,
  config,
  children,
}: PropsWithChildren<HoneycombFilteredDataProviderProps>) => {
  const { min, max } = config;

  const extentMemo = useMemo(
    () => ({
      min: removeDataMinDataMax(min),
      max: removeDataMinDataMax(max),
    }),
    [min, max],
  );

  return (
    <HoneycombExtentConfig.Provider value={extentMemo}>
      <HoneycombDataContext.Provider value={data}>
        {children}
      </HoneycombDataContext.Provider>
    </HoneycombExtentConfig.Provider>
  );
};

HoneycombFilteredDataProvider['displayName'] = 'HoneycombFilteredDataProvider';
